import $ from 'jquery';

export default function bind() {
  $('.popup-help').each((index, elt) => {
    const selector = elt.getAttribute('selector');
    $(elt).popup({
      popup: selector,
      on: 'hover',
      position: 'right center',
      lastResort: 'top left',
      offset: 0,
    });
  });
}



// WEBPACK FOOTER //
// ./src/plugins/popup-help.js